import { render, staticRenderFns } from "./PartsModal.vue?vue&type=template&id=8115b8b0&scoped=true&lang=pug"
import script from "./PartsModal.vue?vue&type=script&lang=js"
export * from "./PartsModal.vue?vue&type=script&lang=js"
import style0 from "./PartsModal.vue?vue&type=style&index=0&id=8115b8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8115b8b0",
  null
  
)

export default component.exports